import React from 'react';

import GlobalStyles from '../../Main/GlobalStyles';

const Globals = () => {
	return (
		<>
			<GlobalStyles />
		</>
	);
};

export default Globals;
